import {
  IconLayerProps,
  PathLayerProps,
  PolygonLayerProps,
  ScatterplotLayerProps,
} from "@deck.gl/layers";

import { XYLocation } from "@nens/deck-gl";

import { COLORS } from "./map-color-consts";
import { ICON_MAPPING } from "./map-icon-consts";

const LINE_WIDTH_PX = 3;

export const DEFAULT_PATH_LAYER_PROPS: Partial<PathLayerProps<XYLocation>> = {
  positionFormat: `XY`,
  _pathType: "open",
  opacity: 1,
  capRounded: true,
  jointRounded: true,
  getPath: (d) => d.flat().flat(),
  getWidth: LINE_WIDTH_PX,
  widthUnits: "pixels",
  pickable: false,
  getColor: COLORS.MAP_LINE,
} as const;

export const DEFAULT_POLYGON_LAYER_PROPS: Partial<PolygonLayerProps<XYLocation>> = {
  lineWidthMinPixels: LINE_WIDTH_PX,
  lineWidthUnits: "pixels",
  getPolygon: (d) => d.flat().flat(),
  getElevation: 0,
  getFillColor: COLORS.MAP_LINE_50,
  getLineColor: COLORS.MAP_LINE,
  getLineWidth: 1,
  positionFormat: "XY",
  visible: true,
  pickable: false,
} as const;

export const DEFAULT_ICON_LAYER_PROPS: Partial<IconLayerProps<XYLocation>> = {
  iconAtlas: "/assets/images/iconAtlas2.png", // "iconAtlas2" because "iconAtlas" can still be cached witht the wrong icons
  iconMapping: ICON_MAPPING,
  sizeUnits: "pixels",
  getSize: 25,
  getPosition: (d) => d,
  pickable: true,
  billboard: false,
} as const;

export const DEFAULT_POINT_LAYER_PROPS: Partial<ScatterplotLayerProps<XYLocation>> = {
  getPosition: (d) => d,
  getRadius: 7,
  getFillColor: COLORS.MAP_LINE,
  radiusUnits: "pixels",
  pickable: true,
  billboard: false,
};
